import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/utils/WovnTranslationProtector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/lib/fonts.ts\",\"import\":\"Be_Vietnam_Pro\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"variable\":\"--font-be\",\"preload\":true,\"fallback\":[\"system-ui\",\"arial\"],\"adjustFontFallback\":false}],\"variableName\":\"beVietnamPro\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/lib/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"system-ui\",\"arial\"],\"adjustFontFallback\":false}],\"variableName\":\"Inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/lib/fonts.ts\",\"import\":\"Lato\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"variable\":\"--font-lato\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"游ゴシック Medium\",\"YuGothic\",\"游ゴシック体\",\"Sawarabi Gothic\",\"ヒラギノ角ゴ Pro W3\",\"メイリオ\",\"sans-serif\"],\"adjustFontFallback\":false}],\"variableName\":\"Lato\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/lib/fonts.ts\",\"import\":\"Cormorant\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"600\",\"700\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-cormorant\"}],\"variableName\":\"cormorant\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/lib/fonts.ts\",\"import\":\"Noto_Serif_JP\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"900\"],\"variable\":\"--font-noto-serif\"}],\"variableName\":\"notoSerifJP\"}");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalData"] */ "/app/src/components/organisms/global-data/GlobalData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeSearch","HOTEL","CITY"] */ "/app/src/components/organisms/hotel-result/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/layouts/BodyWithFooter.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/ButtonLogin.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/CallButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/layouts/header/CriHeader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/Emergency.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/LocaleSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/layouts/header/MobileMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/OfferBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/SearchBar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/TemplateHotelSpecificMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/layouts/header/TemplateMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/layouts/LazyDetailPopup.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/premier-residence/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/TriplaBot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalTextProvider"] */ "/app/src/contexts/GlobalTextContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/appProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/custom.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/safari-ios.css");
